export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativação de cheque eletrônico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta de crédito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de ativação"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar cheque eletrônico"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativo"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelado"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativando"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devolvendo"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pendente"])}
  }
}